import React from 'react'
import Avatar from "@mui/material/Avatar";
import { Contractor, User } from '../models';
import { blue, } from '@mui/material/colors';

const RelicAvatar: React.FC<{
    size: number;
    user: User;
    avatarBgColor?: string;
    display: boolean;

}> = ({size= 40, avatarBgColor = blue[500], display= true, user}) => {
    return (
        <Avatar sx={{
            width:size, height: size,
            bgcolor: avatarBgColor,
            display: (display) ? 'flex' : 'none'
        }} src={'http://localhost:1337' + user.PhotoUrl} alt={((user as Contractor).Name || user.FirstName).toUpperCase()} />
    )
}

export default RelicAvatar
